import { useState, useRef, React, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';

export default function LessonNoteTextArea(props) {
	const { value, setValue } = props;
  const { t } = useLanguage();
  
	const [changed, setChanged] = useState(false);

	const inputRef = useRef();

	useEffect(() => {
    inputRef.current.style.height = 'auto';
		inputRef.current.style.height = inputRef.current.scrollHeight + `px`;
	}, [])

	function onChangeInput(e) {
    inputRef.current.style.height = 'auto';
    inputRef.current.style.height = inputRef.current.scrollHeight + `px`;

		setValue(e.target.value);
		setChanged(true);
	}

	function onFocusInput(e) {
	}

	function onBlurInput(e) {
	}

  function onPress(e) {
  }

 
	return (
    <InputWrapper>
      <Input
        ref={inputRef}
        value={value}
        rows={1}
        placeholder='수업중 특이사항을 입력해주세요'
        onChange={onChangeInput}
        onFocus={onFocusInput}
        onBlur={onBlurInput}
        onKeyPress={onPress} />
    </InputWrapper>
  )
}

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
  
  padding: 10px;

  width: calc(100% - 20px);
  max-height: 200px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
`;

const Input = styled.textarea`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;
  
  resize: none;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};
  border: 0px solid transparent;

  padding: 0px;
  margin: 0px;

	outline: none;

  background-color: ${props => props.theme.subBackground};

	::placeholder {
    color: ${props => props.theme.line};
	}

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		background-color: ${props => props.theme.line};
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background-color: ${props => props.theme.background};
		border-radius: 200px;
	}
`;